export enum WalletDataVisualization {
    INVESTOR = 'INVESTOR',
    SECONDARY_ACCESS = 'SECONDARY_ACCESS'
}
